import PartImg1 from "../assets/images/resources/partImg1-1.png";
import PartImg2 from "../assets/images/resources/partImg1-2.png";
import PartImg3 from "../assets/images/resources/partImg1-3.png";
import PartImg4 from "../assets/images/resources/partImg1-4.png";
import PartImg5 from "../assets/images/resources/partImg1-5.png";

import PartHoverImg1 from "../assets/images/resources/partHoverImg1-1.png";
import PartHoverImg2 from "../assets/images/resources/partHoverImg1-2.png";
import PartHoverImg3 from "../assets/images/resources/partHoverImg1-3.png";
import PartHoverImg4 from "../assets/images/resources/partHoverImg1-4.png";
import PartHoverImg5 from "../assets/images/resources/partHoverImg1-5.png";

export const partners = [
  {
    partImg: PartImg1,
    partHoverImg: PartHoverImg1,
    partLink: "#",
  },
  {
    partImg: PartImg2,
    partHoverImg: PartHoverImg2,
    partLink: "#",
  },
  {
    partImg: PartImg3,
    partHoverImg: PartHoverImg3,
    partLink: "#",
  },
  {
    partImg: PartImg4,
    partHoverImg: PartHoverImg4,
    partLink: "#",
  },
  {
    partImg: PartImg5,
    partHoverImg: PartHoverImg5,
    partLink: "#",
  },
];
